// extracted by mini-css-extract-plugin
module.exports = {"blogSearch":"BlogPage_blogSearch__ud0cL"};